export default __webpack_public_path__ + "static/media/The Journey.b2414f11.png";